declare const $: any;

import ComponentSettings from './ComponentSettings';
import Tabs from '../Interfaces/Tabs';
import { availablePlugins } from '../availablePlugins';

export default class Input extends ComponentSettings {
    private component: any;
    private tabs: Array<Tabs> = [];

    constructor(section) {
        super(section);
        this.component = section.component;
        this.buildTemplate();
    }

    private buildTemplate() {

        /* Main fieldset
        -------------------------------------------------- */

        const $mainTab: Array<JQuery> = [];

        // Type
        const typeOptions: Array<string> = ['text', 'color', 'date', 'datetime-local', 'email', 'hidden', 'month', 'number', 'password', 'tel', 'time', 'url', 'week'];
        const typeData = {
            name: 'type',
            label: 'Type',
            data: {
                prop: 'type',
            },
            value: this.component.type
        }
        const $selectType = this.addSelect(typeData, typeOptions);
        $mainTab.push($selectType);

        // Name
        const nameData = {
            data: {
                prop: 'name'
            },
            label: 'Name',
            name: 'name',
            value: this.component.name
        }
        const $inputName = this.addInput(nameData);
        $mainTab.push($inputName);

        // Value
        const valueData = {
            data: {
                prop: 'value'
            },
            label: 'Default value',
            name: 'value',
            value: this.component.value
        }
        const $inputValue = this.addInput(valueData);
        $mainTab.push($inputValue);

        // Label
        const labelData = {
            data: {
                prop: 'label'
            },
            label: 'Label',
            name: 'label',
            value: this.component.label
        }
        const $inputLabel = this.addInput(labelData);
        $mainTab.push($inputLabel);

        // Placeholder
        const placeholderData = {
            data: {
                prop: 'placeholder'
            },
            label: 'Placeholder',
            name: 'placeholder',
            value: this.component.placeholder
        }
        const $inputPlaceholder = this.addInput(placeholderData);
        $mainTab.push($inputPlaceholder);

        // HelpText
        const helperData = {
            data: {
                prop: 'helper'
            },
            label: 'Helper',
            name: 'helper',
            tooltip: 'Helper text displayed below the field.',
            value: this.component.helper
        }
        const $inputHelper = this.addInput(helperData);
        $mainTab.push($inputHelper);

        // Class
        const clazzData = {
            data: {
                prop: 'clazz'
            },
            label: 'Class',
            name: 'clazz',
            value: this.component.clazz
        }
        const $inputClazz = this.addInput(clazzData);
        $mainTab.push($inputClazz);

        // width
        const isFormHorizontal = $('#fg-form-wrapper form').hasClass('form-horizontal');
        const selectWidthData = {
            data: {
                prop: 'width'
            },
            disabled: !isFormHorizontal,
            name: 'input-width-data',
            tooltip: 'The width can be set only in horizontal forms. It has no effect on others layouts.',
            label: 'Width',
            value: '100%'
        }
        const selectWidthOptions: Array<string> = ['33%', '50%', '66%', '100%'];
        const $selectWidth = this.addSelect(selectWidthData, selectWidthOptions);

        $mainTab.push($selectWidth);

        // Attr
        const checkData = {
            checkboxes: [{
                checked: this.component.attr.find(a => a.name === 'disabled') !== undefined,
                data: {
                    prop: 'disabled'
                },
                label: 'Disabled',
                name: 'disabled',
                value: 'disabled'
            },
            {
                checked: this.component.attr.find(a => a.name === 'readonly') !== undefined,
                data: {
                    prop: 'readonly'
                },
                label: 'Readonly',
                name: 'readonly',
                value: 'readonly'
            }, {
                checked: this.component.attr.find(a => a.name === 'required') !== undefined,
                data: {
                    prop: 'required'
                },
                label: 'Required',
                name: 'required',
                value: 'required'
            }],
            label: '',
            plugin: 'niceCheck'
        }
        const $checkMisc = this.addCheckboxes(checkData);
        $mainTab.push($checkMisc);

        // icon
        const iconData = {
            data: {
                prop: 'icon',
                uniqid: this.makeUniqId(5),
                iconset: $('body').attr('data-icon-font'),
                icon: this.component.icon
            },
            label: 'icon',
            helper: 'You can change the icon library in the <em>Main Settings</em>.',
            name: 'icon'
        }
        const $inputIcon = this.addIconPicker(iconData);
        $mainTab.push($inputIcon);

        // icon position
        const iconPositionData = {
            data: {
                prop: 'iconPosition'
            },
            name: 'icon-position',
            label: 'Icon position',
            value: 'before'
        }
        const iconPositionOptions: any = [
            {
                'Before the field': 'before'
            },
            {
                'After the field': 'after'
            }
        ];
        const $selectIconPosition = this.addSelect(iconPositionData, iconPositionOptions);

        $mainTab.push($selectIconPosition);

        this.tabs.push({
            title: 'Main',
            id: 'tab-main',
            content: $mainTab
        });

        /* Plugins
        -------------------------------------------------- */

        const $pluginsTab: Array<JQuery> = [];

        // Plugins
        const pluginsOptions: Array<string> = [];
        availablePlugins.input.forEach(Pl => {
            pluginsOptions.push(Pl.name);
        });
        const activePluginsNames: Array<string> = [];
        this.component.plugins.forEach(pl => {
            activePluginsNames.push(pl.objectName);
        });
        const pluginsData = {
            data: {
                prop: 'plugins'
            },
            label: 'Select plugins',
            name: 'plugins[]',
            value: activePluginsNames
        }
        const $selectPlugins = this.addSelect(pluginsData, pluginsOptions);
        $pluginsTab.push($selectPlugins);

        this.component.plugins.forEach(pl => {
            const $pluginFieldset = this.loadPlugin(pl, this);
            $pluginsTab.push($pluginFieldset);
        });

        this.tabs.push({
            title: 'Plugins',
            id: 'tab-plugins',
            content: $pluginsTab
        });

        this.renderSection(this.tabs);
    }
}
